// client/src/locales/nl`

const nl = {
  translation: {
    publication: {
      subjects: "Alle onderwerpen", 
      sort: "Sorteer", 
      date_newest: "Sorteer op datum (Nieuwste)", 
      date_oldest: "Sorteer op datum (Oudste)", 
      title_a_z: "Sorteer op titel (A-Z)", 
      title_z_a: "Sorteer op titel (Z-A)" ,
      nadaa: "Ontmoet ons in onze stand: Voorlopig zijn er geen evenementen gepland.",
      search_placeholder: "Zoek op titel en auteur",
      date_from: "Vanaf",
      date_to: "Tot",
      search_button: "Zoek",
      no_results: "Geen publicaties gevonden."
    },
    webinar: {
      subjects: "Alle onderwerpen", 
      countries: "Alle landen",
      no_results: "Geen webinars gevonden.",
      watch_this: "Bekijk deze"
    },
    conference: {
      subjects: "Alle onderwerpen", 
      countries: "Alle landen",
      no_results: "Geen congressen gevonden.",
      read_this: "Bekijk deze"
    },
    videos: {
      subjects: "Alle onderwerpen", 
      countries: "Alle landen",
      no_results: "Geen video's gevonden.",
      read_this: "Bekijk de opname"
    },
    shop: {
      order: "Jouw bestelling", 
      place_order: "Materialen aanvragen", 
      filter: "Alle onderwerpen", 
      download: "Download", 
      prev: "Vorige stap",
      form: "Adresgegevens", 
      max: "Je hebt het maximaal toegestaane te bestellen producten bereikt",
      aside_title: "Jouw bestelling",
      selected_items: "brochures geselecteerd",
      thanks: "Bedankt",
      form_submit: 'Aanvragen',
    },
    related_articles: {
      link: "Lees dit artikel",
      title: "Deze artikelen kunnen interessant voor je zijn"
    },
    form: {
      form_submit: 'Versturen',
      make_a_choice: 'Maak een keuze',
    },
    general: {
      readMore: 'Lees meer',
      loading: 'Laden',
      close: 'Sluit',
      disclaimer: 'Alleen voor voedings- en gezondheidsprofessionals', 
    },
    blocks: {
      imageContainer: {
        error: 'Fout bij laden afbeelding'
      },
      mapBlock: {
        visitWebsite: 'Bekijk website',
        map: 'Kaart',
        list: 'Lijst',
      },
    },
    searchbar: {
      label: 'Waar ben je naar op zoek?',
      placeholder: 'bijvoorbeeld: voedingsstoffen in melk',
    },
    regionSwitch: {
      title: "FrieslandCampina, uw wereldwijde zuivelpartner",
      description: "Wij zijn een wereldwijde zuivelcoöperatie, actief in meer dan 50 landen",
      language: "Nederland"
    },
    footer: {
      links: {
        privacy: 'Privacy',
        terms_conditions: 'Algemene voorwaarden',
      },
      follow_us: 'Volg ons',
    },
    404: {
      title: 'Sorry, we kunnen deze pagina niet vinden',
      description:
        'De pagina bestaat niet (meer) of is misschien verhuisd. Gebruik de zoekmachine om de informatie te vinden die je zoekt.',
      link: '/',
      homepage: 'Naar homepage',
    },
    cookiebar: {
      title: 'Welkom!',
      description:
        'Waarschijnlijk heeft u al ervaring met bedrijven die op uw computer, tablet of telefoon cookies plaatsen. Friesland Campina maakt gebruik van cookies en u kunt kiezen uit onderstaande opties:',
      accept: 'Akkoord',
      complete: {
        title: 'Complete cookies',
        description:
          "Met behulp van deze cookies verbeteren we de website, maken we een koppeling met social media, kunt u video's bekijken en een adviseur zoeken.",
      },
      limited: {
        title: 'Beperkte cookies',
        description:
          "Met deze cookies kunt u een adviseur zoeken, video's bekijken en kunnen wij de website verbeteren.",
      },
      functional: {
        title: 'Functionele cookies',
        description:
          "Deze cookies zijn noodzakelijk voor het functioneren van de website. U kunt geen video's bekijken en geen adviseur zoeken.",
      },
      decline: 'Nee',
      statement: 'Cookieverklaring',
      missing: 'Je cookies moeten ingeschakeld zijn om deze video te bekijken.',
      settings: "Cookie instellingen"
    },
    searchResults: {
      title: 'Jouw zoekopdracht',
      noSearchTerm: 'Je hebt geen zoekterm opgegeven',
      types: {
        page: 'Pagina',
        news: 'Nieuws',
        story: 'Verhaal',
        article: "Artikel",
        webinar: "Webinar",
        conference: "Conferentie",
        events: "Evenement", 
      },
      noResults: 'Geen resultaten gevonden. Probeer het opnieuw met deze tips:',
      noResultsTips: {
        spelling: 'Controleer je spelling',
        describe: 'Beschrijf je zoekopdracht anders',
        shorter: 'Maak je zoekopdracht kleiner',
      },
    },
    filter: {
      noResults:
        'Geen resulten gevonden voor deze categoriey. Kies een andere category of klik <a href="/nl/nieuws/">hier</a> al het nieuws te bekijken.',
    },
    pagination: {
      previous: 'Vorige',
      next: 'Volgende',
    },
    show_button: {
      more: 'Toon meer',
      less: 'Toon minder'
    },
    share_link: {
      title: 'Delen op'
    },
    news: {
      categories: 'Categoriën:',
    },
    story: {
      categories: 'Categoriën:',
    },
    filters: {
      filter_on: 'Filter op:',
      category: 'Categorie',
      all_categories: 'Alle categorieën',
      year: 'Jaar',
      all_years: 'Alle jaren',
    },
    formMessage: 'Controleren...',
    highlights: {
      title: 'Actueel bij FrieslandCampina',
      footer_copy: 'Lees meer over de laatste ontwikkelingen bij FrieslandCampina:',
      link_copy: 'Bekijk ons nieuws',
      link_url: '/nl/nieuws/'
    },
    certificate:{
      download: "Klik hier om jouw certificaat te downloaden",
      find_download: "Je vindt het certificaat dan in de download folder"
    },
    newsletter: {
      message: 'Van welk land wil je de nieuwsbrief ontvangen?',
      placeholder: 'Selecteer je land',
      countries: {
        asia: 'Azië',
        china: 'China',
        indonesia: "Indonesië",
        belgium_nl: 'België NL',
        belgium_fr: 'België FR',
        netherlands: "Nederland",
        nigeria: 'Nigeria',
        pakistan: 'Pakistan',
        mexico: 'Mexico',
        other: 'Overige landen'
      }
    }
  },
}

export default nl;
